/**
 * IP18 App — exclusive accordion (PC) / native-scroll tabs (mobile).
 * One index drives image + accordion + tab + mobile body. Always one open.
 */
(function () {
  'use strict';

  class Ip18AppSwitch extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this._onClick = this._onClick.bind(this);
      this.addEventListener('click', this._onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
    }

    _onClick(event) {
      var btn = event.target.closest('[data-ip18-app-trigger], [data-ip18-app-tab]');
      if (!btn || !this.contains(btn)) return;
      var index = Number(btn.getAttribute('data-index'));
      if (isNaN(index)) return;
      this._select(index);
    }

    _select(index) {
      this.querySelectorAll('[data-ip18-app-shot]').forEach(function (el, i) {
        el.classList.toggle('is-active', i === index);
      });
      this.querySelectorAll('[data-ip18-app-item]').forEach(function (el, i) {
        var on = i === index;
        el.classList.toggle('is-open', on);
        var trigger = el.querySelector('[data-ip18-app-trigger]');
        if (trigger) trigger.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
      this.querySelectorAll('[data-ip18-app-tab]').forEach(function (el, i) {
        var on = i === index;
        el.classList.toggle('is-active', on);
        el.setAttribute('aria-selected', on ? 'true' : 'false');
        el.tabIndex = on ? 0 : -1;
        if (on && el.scrollIntoView) {
          el.scrollIntoView({ inline: 'center', block: 'nearest' });
        }
      });
      this.querySelectorAll('[data-ip18-app-tab-body]').forEach(function (el, i) {
        el.classList.toggle('is-active', i === index);
        el.hidden = i !== index;
      });
    }
  }

  if (!customElements.get('ip18-app-switch')) {
    customElements.define('ip18-app-switch', Ip18AppSwitch);
  }
})();
